import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-pencil',
  templateUrl: './icon-pencil.component.html',
  styleUrls: ['./icon-pencil.component.scss']
})
export class IconPencilComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
